import React from 'react';
import { Row, Col, Card } from 'react-bootstrap';

const VacationCard = ({
  title,
  vacationCard = {},
  excessAccumulatedPeriods,
  rrhh,
  proportionalVacation,
  hasExtremeZoneVacation,
  adminDays = false
}) => {
  const shouldShowItem = item => adminDays || item.always || item.show;

  const typeRows = adminDays
    ? [
      { id: 'generated', text: '(+) Generadas' },
      { id: 'taken', text: '(-) Tomadas' },
      { id: 'requested', text: '(-) Solicitadas' }
    ]
    : [
      { id: 'legal_or_generated', text: proportionalVacation ? '(+) Legales' : '(+) Generadas', always: true },
      { id: 'proportional', text: '(+) Proporcionales', show: proportionalVacation },
      { id: 'extreme_zone', text: '(+) Zona Extrema', show: hasExtremeZoneVacation },
      { id: 'taken', text: '(-) Tomadas', always: true },
      { id: 'requested', text: '(-) Solicitadas', always: true }
    ];

  const amountRows = adminDays
    ? [
      { id: 'accumulated', text: `${vacationCard.accumulatedVacation ?? 0} días` },
      { id: 'taken', text: `${vacationCard.vacationsTakenToDate ?? 0} días` },
      { id: 'to_take', text: `${vacationCard.vacationToTake ?? 0} días` }
    ]
    : [
      { id: 'accumulated', text: `${vacationCard.accumulatedVacation ?? 0} días`, always: true },
      { id: 'proportional', text: `${vacationCard.proportionalValue ?? 0} días`, show: proportionalVacation },
      { id: 'extreme', text: `${vacationCard.extremeZoneValue ?? 0} días`, show: hasExtremeZoneVacation },
      { id: 'taken', text: `${vacationCard.vacationsTakenToDate ?? 0} días`, always: true },
      { id: 'to_take', text: `${vacationCard.vacationToTake ?? 0} días`, always: true }
    ];

  const RenderRows = ({ rows }) =>
    rows.map(item => {
      const visible = shouldShowItem(item);
      return (
        <p key={item.id} className={visible ? '' : 'invisible'}>
          {visible ? item.text : '\u00A0'}
        </p>
      );
    });

  return (
    <Card className="card-yellow-border w-100">
      <Card.Body className="d-flex flex-column">
        <Card.Header>{title}</Card.Header>
        <Row className="mt-3 flex-grow-1">
          <Col xs={6}>
            <Card.Title className="text-uppercase">Tipo</Card.Title>
            <RenderRows rows={typeRows} />
          </Col>
          <Col xs={6} className="attendance-card">
            <Card.Title className="text-uppercase">Cantidad</Card.Title>
            <RenderRows rows={amountRows} />
          </Col>

          <Col xs={12}>
            <hr className="mt-0 mb-3 yellow" />
          </Col>

          <Col xs={12}>
            <Row>
              <Col>
                <p>Acumulados</p>
              </Col>
              <Col className="attendance-card">
                <p>{vacationCard.vacationsAvailable ?? 0} días</p>
              </Col>
            </Row>
          </Col>
        </Row>

        {excessAccumulatedPeriods && (
          <p className="warning-excess-accumulated-periods">Tiene{rrhh ? '' : 's'} más de dos períodos acumulados</p>
        )}
      </Card.Body>
    </Card>
  );
};

export default VacationCard;
